/**
 * A business image, as a URL an `<img>` can show.
 *
 * The same `readImageDataUrl` the letterhead uses, so the preview and the print
 * resolve the image through ONE code path. A preview that loads bytes a
 * different way is a preview that can be right while the invoice is wrong, and
 * the person checking their letterhead is the only test of it that matters.
 *
 * Enabled only when there is something to show, and keyed on the ATTACHMENT ID
 * rather than the business: replacing a logo writes a new id, so the old bytes
 * are never shown against the new mark.
 */
import { useQuery } from '@tanstack/react-query';
import { getDb } from '@data/db/database';
import { readImageDataUrl } from '@data/services/attachmentService';

export function useAttachmentPreview(
  businessId: string | null,
  attachmentId: string | undefined,
) {
  return useQuery({
    queryKey: ['attachmentPreview', businessId, attachmentId ?? null],
    queryFn: async (): Promise<string | undefined> =>
      readImageDataUrl(getDb() as never, businessId ?? '', attachmentId),
    enabled: businessId !== null && Boolean(attachmentId),
  });
}